import { useState } from "react";
import { useNavigate } from "react-router-dom";

const DeleteAccountScreen = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleDelete = async () => {
  try {
    const res = await fetch("https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/deleteUser", 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa("quiz_admin:s*Q&FLx^9BUQ"),
          },
          body: JSON.stringify({email}),
        });

    const data = await res.json();
    if (data.success) {
      navigate("/delete/success")
    } else {
      console.log("Ошибка: " + data.error);
    }
  } catch (err) {
    console.error(err);
    console.log("Ошибка подключения к серверу");
  }
};

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <p className="text-lg font-medium text-gray-800 mb-4">Delete account</p>
      <p className="text-center text-md text-gray-400 mb-6">
        Provide your email, if you want to delete
        <br /> your account
      </p>

      {/* Поле для почты */}
      <input
        type="email"
        placeholder="Your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-[350px] max-w-md p-5 border border-gray-300 rounded-full mb-4 focus:outline-none focus:ring-2 focus:ring-pinkCustom"
      />

      {/* Кнопка удаления */}
      <button
        onClick={handleDelete}
        className="w-[350px] max-w-md py-5 bg-pinkCustom text-white rounded-full hover:bg-pinkCustom transition"
      >
        Delete
      </button>
    </div>
  );
};

export default DeleteAccountScreen;
